import { render } from "./RuleReportView.vue?vue&type=template&id=37989370"
import script from "./RuleReportView.vue?vue&type=script&lang=js"
export * from "./RuleReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37989370"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37989370', __exports__)) {
    api.reload('37989370', __exports__)
  }
  
  module.hot.accept("./RuleReportView.vue?vue&type=template&id=37989370", () => {
    api.rerender('37989370', render)
  })

}


export default __exports__